import sanityClient from '@sanity/client'

export default sanityClient ({
    projectId: "5btmzis4",
    dataset:"production"
})